import { _notificationTemplate } from "../constants/api";


export const createtNotificationTemplates = async (data) => {
  try {
 
    const response= await fetch(`${_notificationTemplate}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
    const responseJSON = await response.json();

    return responseJSON;
  } catch (error) {
    console.log('Error occured in the user register api ==> ', error);
  }
};